import { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import "./assets/css/animate.css";
import "react-phone-number-input/style.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Home } from "./pages/landingPage";
import { ContactUS } from "./pages/contact";
import { Footer } from "./component/footer";
import { AdminLogin } from "./pages/admin/login";
import Sidebar from "./pages/admin/sidebar";
import { NavbarAdmin } from "./pages/admin/navbarAdmin";
import { Dashboard } from "./pages/admin/dashboard";
import { Employees } from "./pages/admin/employees";
import { AddEmployee } from "./pages/admin/addEmployee";
import { EmployeeDetail } from "./pages/admin/employeeDetail";
import { useDispatch, useSelector } from "react-redux";
import adminAction from "./redux/admin/action";
import axios from "axios";
import api from "./api";
import { AdminTask } from "./pages/admin/tasks";
import { EmployeeLogin } from "./pages/employee/login";
import { EmployeeTask } from "./pages/employee/tasks";
import { EmployeeProfile } from "./pages/employee/profile";
import { notify } from "./utils/toast";
import { EditEmployee } from "./pages/admin/editEmploye";
import { EmpLeave } from "./pages/employee/leaves";
import { AdminLeaves } from "./pages/admin/leaves";
import { Attendance } from "./pages/admin/attendance";
import { EmployeeAttendance } from "./pages/employee/attendance";
import Notifications from "./pages/admin/notifications";
import { AdminContact } from "./pages/admin/contact";

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const dispatch = useDispatch();
  const adminStore = useSelector((state) => state.adminReducer);
  const employeeStore = useSelector((state) => state.employeeReducer);

  const { setAdmin } = adminAction;
  const [authType, setAuthType] = useState("");

  const [loader, setLoader] = useState(false);

  console.log(adminStore);

  const checkAdminSession = async () => {
    try {
      let token = localStorage.getItem("admintoken");
      // console.log(token);
      setLoader(true);
      if (token) {
        let payload = {
          token: token,
        };
        const registerationResponse = await api.verifyAdminSession(payload);
        console.log(registerationResponse);

        if (registerationResponse?.token) {
          axios.defaults.headers.common["Authorization"] =
            registerationResponse?.token;
          if (registerationResponse?.token) {
            setIsAdmin(true);
            setAuthType("admin");
          }
        } else {
          dispatch(setAdmin({}));
          localStorage.removeItem("admintoken");
          window.location.href = "/";
        }
      }
      setLoader(false);
    } catch (error) {
      notify.error("Session Expired");

      setLoader(false);
      dispatch(setAdmin({}));
      localStorage.removeItem("admintoken");
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (adminStore?.admin?.admin?.email) {
      checkAdminSession();
    }
  }, []);

  const checkEmployeeSession = async () => {
    try {
      let token = localStorage.getItem("emptoken");
      // console.log(token);
      setLoader(true);
      if (token) {
        let payload = {
          token: token,
        };
        const registerationResponse = await api.verifyEmployeeSession(payload);
        console.log(registerationResponse);

        if (registerationResponse?.token) {
          axios.defaults.headers.common["Authorization"] =
            registerationResponse?.token;
          if (registerationResponse?.token) {
            setIsAdmin(true);
            setAuthType("employee");
          }
        } else {
          dispatch(setAdmin({}));
          localStorage.removeItem("emptoken");
          window.location.href = "/";
        }
      }
      setLoader(false);
    } catch (error) {
      notify.error("Session Expired");
      setLoader(false);
      dispatch(setAdmin({}));
      localStorage.removeItem("emptoken");
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (employeeStore?.employee?.employee?._id) {
      checkEmployeeSession();
    }
  }, []);

  return (
    <div className="App">
      {adminStore?.admin?.admin?.email ? (
        <div id="wrapper">
          <Sidebar
            setIsAdmin={setIsAdmin}
            authType={authType}
            setAuthType={setAuthType}
          />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <NavbarAdmin
                setIsAdmin={setIsAdmin}
                setAuthType={setAuthType}
                authType={authType}
              />
              <Routes>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/employees" element={<Employees />} />
                {/* <Route path="/admin/attendance" element={<Attendance />} /> */}
                <Route path="/admin/tasks" element={<AdminTask />} />
                <Route path="/admin/add-employee" element={<AddEmployee />} />
                <Route
                  path="/admin/edit-employee/:id"
                  element={<EditEmployee />}
                />
                <Route
                  path="/admin/employee/:id"
                  element={<EmployeeDetail />}
                />
                <Route path="/admin/leaves" element={<AdminLeaves />} />
                <Route
                  path="/admin/notifications"
                  element={<Notifications />}
                />
                <Route path="/admin/contact" element={<AdminContact />} />
              </Routes>
            </div>
          </div>
        </div>
      ) : authType == "employee" ? (
        <>
          <div id="wrapper">
            <Sidebar
              setIsAdmin={setIsAdmin}
              authType={authType}
              setAuthType={setAuthType}
            />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <NavbarAdmin
                  setIsAdmin={setIsAdmin}
                  setAuthType={setAuthType}
                  authType={authType}
                />
                <Routes>
                  <Route path="/employee/tasks" element={<EmployeeTask />} />
                  <Route
                    path="/employee/profile"
                    element={<EmployeeProfile />}
                  />
                  <Route
                    path="/employee/attendance"
                    element={
                      <EmployeeAttendance
                        employeeId={employeeStore?.employee?.employee?._id}
                      />
                    }
                  />
                  <Route path="/employee/leaves" element={<EmpLeave />} />
                </Routes>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<ContactUS />} />
            <Route
              path="/admin-login"
              element={
                <AdminLogin setIsAdmin={setIsAdmin} setAuthType={setAuthType} />
              }
            />
            <Route
              path="/employee-login"
              element={
                <EmployeeLogin
                  setIsAdmin={setIsAdmin}
                  setAuthType={setAuthType}
                />
              }
            />
          </Routes>
          <Footer />
        </>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000} // 3s
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // dark | light | colored
      />
    </div>
  );
}

export default App;
